import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  sortableContainer,
  sortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import { HTTP } from "../../api/resources";
import arrayMove from "array-move";
import ProfileLimit from "../Helpers/Modal/InfoModals/ProfileLimit";

export default function PagesIndex(props) {
  const filteredPublicPages = props.public_pages
  const filteredIframePages = props.iframe_pages
  const iframeCheckouts = props.iframe_checkouts
  const team = props.team;
  const premiumPages = team.feature_flags.includes('pages_v2')

  const [pages, setPages] = useState(props.active_communities);
  const [saving, setSaving] = useState(false);
  const [showItems, setShowItems] = useState(false)
  const [profileLimit, setProfileLimit] = useState(props.profileLimitExceeded)

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      handleSubmit();
    }
  }, [pages]);

  const handleSubmit = () => {
    setSaving(true);
    HTTP.patch("/pages/update_order", {
      pages: pages,
    })
      .then((response) => {
        Alert.show("notice", "Page order saved!");
        setSaving(false);
      })
      .catch((e) => {
        Alert.show("error", "Could not save. Try again or refresh.");
        setSaving(false);
      });
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setPages(arrayMove(pages, oldIndex, newIndex));
  };

  const DragHandle = sortableHandle(() => (
    <span className='mr-2'>
      <i className="fa fa-grip-lines"></i>
    </span>
  ));

  const SortableItem = sortableElement(({ page }) => (
    <div className="list-group-item">
      <div className="list-group-item-body">
        <div className="list-group-item-body-main-invoices">
          <DragHandle />
          <div className="list-item-title-segment mr-2">
              <span style={{fontWeight: 'bold'}}>{team.community_title} Name: </span>{page.title}
          </div>
          <div className="list-item-title-segment d-none-mobile">
              <span style={{fontWeight: 'bold'}}>Members: </span> {page.members_count}
          </div>
          <div className="list-item-total d-none-mobile">
              <span style={{fontWeight: 'bold'}}>Messages: </span> {page.messages_count}
          </div>
        </div>
      </div>
      <div className="list-group-item-actions">
        {!page.archived && (
          <a
            href={`/pages/${page.id}`}
            target="blank"
            className="btn btn-sm btn-outline-primary d-none-mobile"
          >
            {`Enter ${team.community_title}`}
          </a>
        )}
        <a href={`/pages/${page.id}/edit`} className="btn btn-sm btn-primary d-none-mobile">
          <i className="fa fa-pencil"></i> Edit {team.community_title}
        </a>

        <div className="dropdown">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            data-toggle="dropdown"
          >
            Actions
          </button>
          <ul className="dropdown-menu">
            {!page.archived &&
              <li className="dropdown-item">
                <a href={`/pages/${page.id}`}>
                  {`Enter ${team.community_title}`}
                </a>
              </li>
            }
            <li className="dropdown-item">
              <a href={`/pages/${page.id}/edit`}>
              Edit {team.community_title}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  ));

  const SortableContainer = sortableContainer(({ children }) => {
    return <div className="list-group list-group-flush">{children}</div>;
  });

  return (
    <React.Fragment>
      <div>
        <div className="card">
          <div className="card-header flex-header">
            <h4 className="card-title">{props.plural_community_title}</h4>
            <a href="/pages/new?community=true" className="btn btn-primary">
              + Create
            </a>
          </div>
          <div>
            <SortableContainer onSortEnd={onSortEnd} useDragHandle>
              {pages.map((page, index) => (
                <SortableItem key={page.id} index={index} page={page} />
              ))}
            </SortableContainer>
          </div>
          {pages.length == 0 && (
            <div className="card-body">No {props.plural_community_title.toLowerCase()} created yet</div>
          )}
        </div>
      </div>

      {props.archived_communities.length > 0 &&
      <div className="card">
          <div className="card-header flex-header">
            <h4 className="card-title">Archived {props.plural_community_title}</h4>

            <div className="btn-group">
              <button onClick={() => setShowItems(!showItems)}
                name="button"
                className="btn btn-primary"
                type="button">
                {!showItems && <>Show Items</>}
                {showItems && <>Hide Items</>}
              </button>
            </div>
          </div>
        <div>
          {showItems &&
          <div className="list-group list-group-flush">
            {props.archived_communities.map((community, index) => (
              <div key={community.id} className="list-group-item">
                <div className="list-group-item-body">
                  <div className="list-group-item-body-main-invoices">
                  <div className="list-item-title-segment">
                      <span style={{fontWeight: 'bold'}}>{team.community_title} Name: </span>{community.title}
                  </div>
                  <div className="list-item-title-segment d-none-mobile">
                      <span style={{fontWeight: 'bold'}}>Members: </span>{community.members_count}
                  </div>
                  <div className="list-item-total d-none-mobile">
                      <span style={{fontWeight: 'bold'}}>Messages: </span> {community.messages_count}
                  </div>
                  </div>
                </div>
                <div className="list-group-item-actions d-none-mobile">
                  <a
                    href={`/pages/${community.id}/edit`}
                    className="btn btn-sm btn-primary ml-2"
                  >
                    Edit {team.community_title}
                  </a>
                </div>
                <div className="dropdown">
                  <button
                    className="btn btn-primary dropdown-toggle"
                    type="button"
                    data-toggle="dropdown"
                  >
                    Actions
                  </button>
                  <ul className="dropdown-menu">
                    <li className="dropdown-item">
                      <a href={`/pages/${community.id}/edit`}>
                      Edit {team.community_title}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            ))}
          </div>
          }
          </div>
      </div>}

      {premiumPages && 
        <>
          <div>
            <div className="card">
              <div className="card-header flex-header">
                <h4 className="card-title">Public pages</h4>
                <a href="/pages/new?public_page=true" className="btn btn-primary">
                  + Create
                </a>
              </div>
              <div>
                <div className="list-group list-group-flush">
                  {filteredPublicPages && filteredPublicPages.length > 0 && 
                    <div>
                      {filteredPublicPages.map((page, index) => (
                        <div className="list-group-item">
                          <div className="list-group-item-body">
                            <div className="list-group-item-body-main">
                              <span className="ml-2">{page.title}</span>
                              {page.status != "published" && (
                                <span
                                  style={{ textTransform: "capitalize" }}
                                  className="badge badge-info badge-sm ml-2"
                                >
                                  {page.status}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="list-group-item-actions">
                            {page.status == "published" && (
                              <a
                                href={page.url}
                                target="blank"
                                className="btn btn-sm btn-outline-primary"
                              >
                                View Page
                              </a>
                            )}
                            <a
                              href={`/pages/${page.id}/edit`}
                              className="btn btn-sm btn-primary"
                            >
                              <i className="fa fa-pencil"></i> Edit Page
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                  }
                </div>
              </div>
              {filteredPublicPages.length == 0 && (
                <div className="card-body">No public pages created yet</div>
              )}
            </div>
          </div>

          <div>
            <div className="card">
              <div className="card-header flex-header">
                <h4 className="card-title">iFrame Pages</h4>
                <a href="/pages/new?iframe_page=true" className="btn btn-primary">
                  + Create
                </a>
              </div>
              <div>
                <div className="list-group list-group-flush">
                  {filteredIframePages && filteredIframePages.length > 0 && 
                    <div>
                      {filteredIframePages.map((page, index) => (
                        <div className="list-group-item">
                          <div className="list-group-item-body">
                            <div className="list-group-item-body-main">
                              <span className="ml-2">{page.title}</span>
                            </div>
                          </div>
                          <div className="list-group-item-actions">
                            <a
                              href={`/pages/${page.id}/edit`}
                              className="btn btn-sm btn-primary"
                            >
                              <i className="fa fa-pencil"></i> Edit Page
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                  }
                </div>
              </div>
              {filteredIframePages.length == 0 && (
                <div className="card-body">No iframe pages created yet</div>
              )}
            </div>
          </div>

          <div>
            <div className="card">
              <div className="card-header flex-header">
                <h4 className="card-title">iFrame Checkouts</h4>
                <a href="/pages/new?iframe_checkout=true" className="btn btn-primary">
                  + Create
                </a>
              </div>
              <div>
                <div className="list-group list-group-flush">
                  {iframeCheckouts && iframeCheckouts.length > 0 && 
                    <div>
                      {iframeCheckouts.map((page, index) => (
                        <div className="list-group-item">
                          <div className="list-group-item-body">
                            <div className="list-group-item-body-main">
                              <span className="ml-2">{page.title}</span>
                            </div>
                          </div>
                          <div className="list-group-item-actions">
                            <a
                              href={`/pages/${page.id}/edit`}
                              className="btn btn-sm btn-primary"
                            >
                              <i className="fa fa-pencil"></i> Edit Page
                            </a>
                          </div>
                        </div>
                      ))}
                    </div>
                  }
                </div>
              </div>
              {iframeCheckouts.length == 0 && (
                <div className="card-body">No iframe checkouts created yet</div>
              )}
            </div>
          </div>
        </>
      }

      {profileLimit &&
        <ProfileLimit cancel={() => setProfileLimit(false)}/>
      }
    </React.Fragment>
  );
}

PagesIndex.propTypes = {
  pages: PropTypes.array,
};
